import type { Config } from 'msp-integrations'

export const getStyles = (config: Config) => ({
  CustomLinkEmail: `${config.theme.mspComponents?.footer?.link} leading-20`,
  IconWrapper: `${config.theme.font.regular} fill-white pt-1`,
  EmailTextStyles: `text-15 ${config.theme.mspComponents?.footer?.link} leading-20 pl-1.5`,
  PhoneTextStyles: `text-15 ${config.theme.mspComponents?.footer?.link} leading-20 pt-2 pl-1.5`,
  SocialMediaWrapper: 'flex flex-row pt-1 w-fit',
  SocialMediaIcons: `${config.theme.mspComponents?.footer?.link} leading-20`,
  SocialMediaIconsWrapper: 'flex-auto fill-white',
  SocialMediaYTIconsWrapper: 'flex-auto fill-white pl-1 pt-1 md:pt-0',
  FillWhite: 'fill-white',
  FooterMainWrapper: `${config.theme.font.regular} bg-black px-5 pt-16 pb-6 text-white`,
  FooterSubWrapper: 'flex justify-center fill-white md:justify-between',
  MobileSocialMediaWrapper: 'flex justify-center mt-8',
  MobileContactInfoWrapper: 'flex flex-col justify-center items-center mt-10',
  MobileLink: `border-machine1-75 ${config.theme.font.regular} ${config.theme.mspComponents?.footer?.link} leading-32 flex font-normal`,
  GridWrapperStyles: `footer-links grid-cols-1 md:grid-cols-2 lg:grid-cols-4 justify-around ${config.theme.mspComponents?.footer?.gridWrapperStyles} mt-14 mb-9 md:mb-20 text-20`,
  MdRegion1: 'p col-span-2 flex flex-col pt-3 md:col-span-1 text-20',
  NavLinkRegionClass:
    'pl-0 mb-0 md:mb-8 lg:mb-0 lg:pl-10 order-1 lg:order-none',
  NavLinkRegion3Class:
    'pl-0 mb-0 md:mb-8 lg:mb-0 lg:pl-10 order-2 lg:order-none',
  NavLinksRegion: 'flex flex-col gap-2',
  MdRegion4: 'col-span-2 md:col-span-1 text-20',
  AppStoreWrapper: 'flex w-full flex-row pt-3',
  AppleStoreWrapper: 'flex flex-col gap-2 pr-3',
  GoogleStoreWrapper: 'flex flex-col gap-2',
  PriceInfoWrapper: `text-14 ${config.theme.mspComponents?.footer?.priceInfoWrapper} tracking-0.2 pt-10 text-machine1-50`,
  MobilePriceInfoWrapper: `${config.theme.font.regular} text-14 text-gray92 tracking-0 flex flex-col items-center md:items-start`,
  MobileAppStoreWrapper: 'flex pt-6 pb-4',
  MobileAppleStoreWrapper: 'flex-auto pr-2.5',
  MobileGoogleStoreWrapper: 'flex-auto',
  NavFooterRegion: 'py-4 lg:py-0 flex flex-row flex-wrap justify-center',
  CountryModalWrapper:
    'flex cursor-pointer flex-row items-center leading-[1em] py-3 lg:py-0',
  SelectedCountryWrapper: 'ml-1.5 flex',
  SelectedCountryPara: 'h-fit w-fit whitespace-nowrap',
  MobileCopyRightText: 'pt-5 pb-10'
})
